import React, { useState } from "react";

import AchievementTable from "../../containers/Achievement/AchievementTable";
import AchievementButton from "../../containers/Achievement/AchievementButton";

function Achievement(props) {
  const list = window.location.href.split("/");
  const lastValueList = list[list.length - 1].split("=");
  const selectedProfileId = lastValueList.length > 1 ? lastValueList[lastValueList.length - 1] : null;

  const [updating, setUpdating] = useState(null);

  return (
    <div style={{ padding: 8, minHeight: "calc(100vh - 178px)", position: "relative" }}>
      <AchievementButton
        type={props.type}
        department={props.department}
        selectedProfileId={selectedProfileId}
        handleReload={props.handleReload}
        setUpdating={setUpdating}
      />
      <AchievementTable
        adminTab={props.adminTab}
        type={props.type}
        department={props.department}
        selectedProfileId={selectedProfileId}
        handleReload={props.handleReload}
        updating={updating}
        setUpdating={setUpdating}
      />
    </div>
  );
}

export default Achievement;

